/**
 * Therapist Role Detection and Management
 * Phase 7.1 - Session Management System
 *
 * Uses JWT-based moderator detection from Jitsi Meet Redux store
 */
import { isLocalParticipantModerator } from '../base/participants/functions';
import { toState } from '../base/redux/functions';
/**
 * Check if current user is a therapist
 * Therapists are moderators in therapy sessions (role set via JWT token)
 *
 * First checks if local participant has moderator role (after joining conference)
 * Falls back to JWT context.user.moderator claim (available immediately)
 *
 * @param stateful - Redux state or store
 * @returns true if current user is a therapist (moderator)
 */
export function isTherapist(stateful) {
    const state = toState(stateful);
    // Method 1: Check if participant is moderator (after joining)
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    // Method 2: Check JWT token context.user.moderator claim (available before joining)
    const { jwt } = state['features/base/jwt'] || {};
    if (jwt) {
        try {
            // Decode JWT payload (it's base64 encoded, not encrypted)
            const payload = JSON.parse(atob(jwt.split('.')[1]));
            // Check context.user.moderator claim (string 'true' or boolean true)
            if (payload?.context?.user?.moderator === 'true' || payload?.context?.user?.moderator === true) {
                return true;
            }
        }
        catch (error) {
            console.error('[isTherapist] Failed to decode JWT:', error);
        }
    }
    return false;
}
/**
 * Get user role
 * @param stateful - Redux state or store
 */
export function getUserRole(stateful) {
    return isTherapist(stateful) ? 'therapist' : 'patient';
}
/**
 * Get session ID from URL (room name)
 */
export function getSessionId() {
    const path = window.location.pathname;
    // Extract room name from path like /roomname
    const match = path.match(/\/([^\/]+)$/);
    return match ? match[1] : 'default-session';
}
